import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Directive({
  selector: '[appMinimaxi]',
  exportAs: 'minimize',
})
export class MinimaxiDirective {
  private readonly parentElement: HTMLDivElement;
  private minimized$ = new BehaviorSubject<boolean>(true);

  /** Width of the parent "widget" */
  @Input() parentWidth = 0;
  /** Height of the parent "widget" */
  @Input() parentHeight = 0;

  @HostListener('click', ['$event']) onClick($event: MouseEvent): void {
    this.toggle();
  }

  public get isMinimized(): boolean {
    return this.minimized$.getValue();
  }

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.parentElement = this.el.nativeElement.parentElement.parentElement;
    this.parentElement.style.transition = 'all ease-in 200ms';
  }

  toggle(): void {
    this.isMinimized ? this.maximize() : this.minimize();
  }

  minimize(): void {
    if (this.el) {
      this.parentElement.classList.add('minimized');

      this.minimized$.next(true);
    }
  }

  maximize(): void {
    if (this.el) {
      this.parentElement.classList.remove('minimized');

      this.minimized$.next(false);
    }
  }
}
